import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizationService } from '@service/authorization.service';

export class Permission {
  constructor(
    public role:
      | 'RodixAdmin'
      | 'RodixAdminAndRodixEntwicklung'
      | 'Manager'
      | 'ManagerAndSoftwarepartner'
      | 'ManagerAndSoftwarepartnerAndSuperUserKIS'
      | 'ManagerAndSoftwarepartnerAndSuperUserKISAndKISPartner'
      | 'ManagerAndSuperUserKIS'
  ) {}
}

export class AuthRole {
  public static RODIX_ADMIN = new Permission('RodixAdmin');
  public static RODIX_ADMIN_AND_RODIX_ENTWICKLUNG = new Permission('RodixAdminAndRodixEntwicklung');
  public static MANAGER = new Permission('Manager');
  public static MANAGER_AND_SOFTWAREPARTNER = new Permission('ManagerAndSoftwarepartner');
  public static MANAGER_AND_SOFTWAREPARTNER_AND_SUPER_USER_KIS_AND_KIS_PARTNER = new Permission(
    'ManagerAndSoftwarepartnerAndSuperUserKISAndKISPartner'
  );
  public static MANAGER_AND_SOFTWAREPARTNER_SUPER_USER_KIS = new Permission('ManagerAndSoftwarepartnerAndSuperUserKIS');
  public static MANAGER_AND_SUPER_USER_KIS = new Permission('ManagerAndSuperUserKIS');
}

export const AuthGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authorizationService = inject(AuthorizationService);
  if (route.data.role === AuthRole.RODIX_ADMIN.role && authorizationService.isRodixAdmin()) {
    return true;
  }
  if (
    route.data.role === AuthRole.RODIX_ADMIN_AND_RODIX_ENTWICKLUNG.role &&
    authorizationService.isRodixAdminOrRodixEntwicklung()
  ) {
    return true;
  }
  if (route.data.role === AuthRole.MANAGER.role && authorizationService.isManager()) {
    return true;
  }
  if (
    route.data.role === AuthRole.MANAGER_AND_SOFTWAREPARTNER.role &&
    (authorizationService.isManager() || authorizationService.isSoftwarepartner())
  ) {
    return true;
  }
  if (
    route.data.role === AuthRole.MANAGER_AND_SOFTWAREPARTNER_SUPER_USER_KIS.role &&
    (authorizationService.isManager() ||
      authorizationService.isSoftwarepartner() ||
      authorizationService.isSuperUserKIS())
  ) {
    return true;
  }
  if (
    route.data.role === AuthRole.MANAGER_AND_SOFTWAREPARTNER_AND_SUPER_USER_KIS_AND_KIS_PARTNER.role &&
    (authorizationService.isManager() ||
      authorizationService.isSoftwarepartner() ||
      authorizationService.isSuperUserKIS() ||
      authorizationService.isKISPartner())
  ) {
    return true;
  }
  if (
    route.data.role === AuthRole.MANAGER_AND_SUPER_USER_KIS.role &&
    (authorizationService.isManager() || authorizationService.isSuperUserKIS())
  ) {
    return true;
  }

  void router.navigate(['/dashboard']);
  return false;
};
